import React, { useState, useEffect } from "react";
import axios from "axios";
import { X, Motorcycle, CalendarBlank } from "@phosphor-icons/react";

export default function ClientMotosModal({ client, onClose, API }) {
  const [motos, setMotos] = useState([]);
  const [loading, setLoading] = useState(true);

 useEffect(() => {
    const fetchMotos = async () => {
      try {
        console.log("🕵️ Buscando motos para o ID:", client.id); // TIRA-TEIMA AQUI
        const res = await axios.get(`${API}/clients/${client.id}/motorcycles`, {
          withCredentials: true,
        });
        console.log("🏍️ Motos encontradas:", res.data); // VÊ SE A API DEVOLVEU
        setMotos(res.data);
      } catch (error) {
        console.error("Erro ao buscar motos do cliente", error);
      } finally {
        setLoading(false);
      }
    };
    if (client && client.id) {
      fetchMotos();
    }
  }, [client, API]);

  return (
    <div className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-4">
      <div className="bg-[#121212] rounded-xl p-5 sm:p-6 w-full max-w-lg border border-white/10 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-lg text-white">
            Motos de <span className="text-[#00E676]">{client.name}</span>
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-[#1A1A1A] rounded-lg"
          >
            <X size={20} />
          </button>
        </div>

        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin w-8 h-8 border-2 border-[#00E676] border-t-transparent rounded-full"></div>
          </div>
        ) : motos.length === 0 ? (
          <div className="text-center py-8 text-[#A1A1AA]">
            <Motorcycle size={48} className="mx-auto mb-3 opacity-50" />
            <p>Nenhuma moto vinculada a este cliente.</p>
          </div>
        ) : (
          <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-2">
            {motos.map((moto) => (
              <div
                key={moto.id}
                className="bg-[#1A1A1A] border border-white/5 rounded-lg p-4 flex flex-col gap-2"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-bold text-base">{moto.model}</p>
                    <p className="text-sm font-mono text-[#A1A1AA]">
                      {moto.chassis_sn}
                    </p>
                  </div>
                  <span className="bg-[#00E676]/10 text-[#00E676] px-2 py-1 rounded text-xs font-medium">
                    {moto.voltage}V
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-2 pt-2 border-t border-white/5 text-xs text-[#A1A1AA]">
                  <CalendarBlank size={14} />
                  Última movimentação:{" "}
                  {new Date(
                    moto.completed_at || moto.created_at,
                  ).toLocaleDateString("pt-BR")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
